import moment from 'moment';

export const DELIVERY_DATE_MAX_MONTHS = 3;
export const DELIVERY_DATE_MAX_ERROR =
  'Delivery Date cannot be more than 3 months in the future';

export const getMaxDeliveryDate = () =>
  moment().startOf('day').add(DELIVERY_DATE_MAX_MONTHS, 'months');

export const isDeliveryDateBeyondMax = (date) => {
  if (!date) return false;
  return moment(date).startOf('day').isAfter(getMaxDeliveryDate(), 'day');
};
